import classNames from "classnames";
import type { ReactNode } from "react";

const BottomModal = ({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) => {
  if (!open) {
    return;
  }

  return (
    <div
      onClick={onClose}
      className={classNames("fixed inset-0 bg-gray-50 bg-transparent")}
    >
      <div
        className={
          "fixed bottom-0 left-0 right-0 animate-in slide-in-from-bottom-full duration-200"
        }
      >
        <div className="border rounded-t-xl shadow bg-white dark:bg-gray-700 dark:border-gray-800">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BottomModal;
